(async () => {
  const baseComponent = await import(window.theme.modules.baseComponent);

  if (customElements.get('product-sticky-atc')) {
    return;
  }

  customElements.define('product-sticky-atc', class extends baseComponent.default {
    elements = {
      image: '[data-sticky-image]',
      price: '[data-sticky-price]',
      priceCurrent: '[data-sticky-price-current]',
      priceCompare: '[data-sticky-price-compare]'
    };

    render() {
      this.primaryTarget = document.querySelector(
        `#shopify-section-${this.sectionId} [data-primary-product-atc]`
      );

      if (!this.primaryTarget) {
        return;
      }

      this._handleResize = () => this._syncBodyOffset();
      window.addEventListener('resize', this._handleResize);

      this._observer = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          const visible = !entry?.isIntersecting;
          this.toggleAttribute('data-visible', visible);
          document.body.classList.toggle('sticky-product-atc-visible', visible);
          this._syncBodyOffset();
        },
        {
          threshold: 0.1
        }
      );

      this._observer.observe(this.primaryTarget);

      this.listenTo('variantChange', (e, data) => {
        this._updateImage(data.variant);
        this._updatePrice(data.variant);
        this._syncBodyOffset();
      });
    }

    disconnectedCallback() {
      if (this._observer) {
        this._observer.disconnect();
      }
      if (this._handleResize) {
        window.removeEventListener('resize', this._handleResize);
      }
      if (document.body.classList.contains('sticky-product-atc-visible')) {
        document.body.classList.remove('sticky-product-atc-visible');
        document.body.style.setProperty('--sticky-product-atc-height', '0px');
      }
    }

    _syncBodyOffset() {
      const nextHeight = this.hasAttribute('data-visible') ? `${this.offsetHeight}px` : '0px';
      document.body.style.setProperty('--sticky-product-atc-height', nextHeight);
    }

    _updateImage(variant) {
      if (!this.$image || !variant?.featured_media) {
        return;
      }

      const media = variant.featured_media;
      const nextSrc = media.preview_image?.src || media.src;

      if (!nextSrc) {
        return;
      }

      this.$image.src = nextSrc;
      this.$image.alt = media.alt || this.$image.alt;
    }

    _updatePrice(variant) {
      if (!this.$priceCurrent || !variant?.price) {
        return;
      }

      this.$priceCurrent.textContent = this._formatMoney(variant.price);

      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        if (!this.$priceCompare) {
          this.$priceCompare = document.createElement('s');
          this.$priceCompare.className = 'product-sticky-atc__price-compare';
          this.$priceCompare.setAttribute('data-sticky-price-compare', '');
          this.$price.prepend(this.$priceCompare);
        }

        this.$priceCompare.textContent = this._formatMoney(variant.compare_at_price);
      } else if (this.$priceCompare) {
        this.$priceCompare.remove();
        this.$priceCompare = null;
      }
    }

    _formatMoney(cents) {
      const locale = document.documentElement.lang || 'en-US';
      const currency = window.Shopify?.currency?.active || 'USD';
      const showTrailingZeros = this.dataset.showTrailingZeros === 'true';

      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        minimumFractionDigits: showTrailingZeros ? 2 : 0,
        maximumFractionDigits: 2
      }).format(cents / 100);
    }
  });
})();
